module.exports = __webpack_public_path__ + "img/crossIcon.527787ba.svg";